<template>
  <div class="analysis-expand">
    <!-- 需要处理下载  data.row['docs']-->
    <div v-for="(item, i) in list" class="analysis-expand-item" :key="i">
      <div class="left">
        <div>文件名称</div>

        <el-button type="text" @click="download(item)">
          {{ item.name | sliceString }}
        </el-button>
      </div>
      <div class="right">
        <div>上传时间</div>
        <div>
          {{ item.createDt | timeForm }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // todo 改名
  name: 'tableFormOrder',
  data() {
    return {
      list: []
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    download(item) {
      let target = item.url;
      let fileName = item.name;
      if (!target || target === 'null') {
        this.$message.error('连接地址错误');
        return;
      }
      let url = target || '';
      this.$http
        .get(url, {
          responseType: 'arraybuffer'
        })
        .then(function(res) {
          const blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        });
      window.open(url);
    }
  },
  mounted() {
    let { urlNames, urls, urlcreateDt } = this.data.row;
    if (!urlNames) {
      this.list = [];
      return;
    }
    let urlNameList = urlNames.split(';');
    let urlsList = urls.split(';');
    let urlcreateDtList = urlcreateDt.split(';');
    let target = urlNameList.reduce((arr, r, i) => {
      arr[i] = {
        name: r,
        url: urlsList[i],
        createDt: urlcreateDtList[i]
      };
      return arr;
    }, []);
    this.list = target;
  },
  filters: {
    timeForm(value) {
      value = '' + value;
      return value.slice(0, -3);
    },
    sliceString(value) {
      if (!value) {
        return '-';
      }
      let target = '' + value;
      if (target.length > 9) {
        return `${('' + value).slice(0, 8)}...`;
      } else {
        return value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.analysis-expand {
  display: flex;
  flex-wrap: wrap;
  &-item {
    background-color: rgba(247, 249, 252, 1);
    /*background-clip: content-box;*/
    flex: 0 0 25%;
    padding: 20px;
    margin: 16px 20px;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    /*height: 70px;*/
    & > .left {
      display: flex;
      /*background: yellow;*/
      justify-content: space-evenly;
      align-items: flex-start;
      flex-direction: column;
      & > button {
        padding: unset;
      }
    }
    & > .right {
      display: flex;
      align-items: flex-start;
      justify-content: space-evenly;
      flex-direction: column;
    }
  }
}
</style>
